import { GridLegacy as Grid } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';
import {
  StyledStack,
  StyledTwoTitles,
  StyledFirstTitle,
  StyledSecondTitle,
  StyledServiceItem,
  StyledServiceIcon,
  StyledServiceIconWrapper,
  StyledServiceIconBackground,
  StyledServiceTitle,
  StyledServiceDescription,
} from './styles';
import { whyStellarData } from './WhyStellar.data';
import type { WhyStellarProps } from './WhyStellar.types';

export const WhyStellar = ({ ...props }: WhyStellarProps) => {
  return (
    <Section width="small">
      <StyledStack {...props}>
        <StyledTwoTitles>
          <StyledFirstTitle variant="display_sm">
            {whyStellarData.mainText}
          </StyledFirstTitle>
          <StyledSecondTitle variant="regular_500">
            {whyStellarData.description}
          </StyledSecondTitle>
        </StyledTwoTitles>
        <Grid container columnSpacing={{ sm: 8 }} rowSpacing={{ xs: 6, sm: 8 }}>
          {whyStellarData.services.map((data, index) => (
            <StyledServiceItem key={index} item xs={12} md={6}>
              <div>
                <StyledServiceIconWrapper>
                  <StyledServiceIconBackground>
                    <StyledServiceIcon src={data.img} alt={data.title} />
                  </StyledServiceIconBackground>
                </StyledServiceIconWrapper>
              </div>
              <div>
                <StyledServiceTitle variant="strong_400">
                  {data.title}
                </StyledServiceTitle>
                <br />
                <StyledServiceDescription variant="regular_300">
                  {data.description}
                </StyledServiceDescription>
              </div>
            </StyledServiceItem>
          ))}
        </Grid>
      </StyledStack>
    </Section>
  );
};
